// Firebase client SDK config for admin dashboard
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBNgDmSfNztNeTM5RboF3XAvKL47jkFwXw",
  authDomain: "ecoholic-elements-563a1.firebaseapp.com",
  projectId: "ecoholic-elements-563a1",
  storageBucket: "ecoholic-elements-563a1.firebasestorage.app",
  messagingSenderId: "17838266752",
  appId: "1:17838266752:web:e6d1d6a3fb405d0f994965"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
